import { useState, useEffect } from 'react'
import { motion } from "framer-motion"
import { Avatar, Box, CardMedia } from "@mui/material";
import { animate, useMotionValue, useTransform } from 'framer-motion';
import './ParticipantsItem.css'


interface IParticipantProps {
    name: string;
    photo: string;
    vote: number;
}


export const ParticipantsItemArchive: React.FC<IParticipantProps> = ({ name, photo, vote }) => {


    useEffect(() => {

    }, [])

    return (

        <li className="participant_item_archive" >
            <div>{name}</div>
            <div className="img_wrapper">
                <img src={photo} alt="" />
            </div>

            <div>
                number of votes - {vote}
            </div>
        </li>
    )
}
